var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.activity.type === _vm.ActivityTypes.USER_STATUS_CHANGED.id
    ? _c("UserStatusChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.BLOCK_VISITOR.id
    ? _c("VisitorBlocked", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.UNBLOCK_VISITOR.id
    ? _c("VisitorUnBlocked", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_ADDED.id
    ? _c("UserAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHANNEL_CREATED.id
    ? _c("ChannelCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHANNEL_REMOVED.id
    ? _c("ChannelRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHAT_OPENED.id
    ? _c("ChatOpened", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHAT_CLOSED.id
    ? _c("ChatClosed", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEBHOOK_ADDED.id
    ? _c("WebhookAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WEBHOOK_REMOVED.id
    ? _c("WebhookRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TRIGGER_ADDED.id
    ? _c("TriggerAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TRIGGER_REMOVED.id
    ? _c("TriggerRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TRIGGER_UPDATED.id
    ? _c("TriggerUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.DEPARTMENT_ADDED.id
    ? _c("DepartmentAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.DEPARTMENT_REMOVED.id
    ? _c("DepartmentRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.ROLE_ADDED.id
    ? _c("RoleAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.ROLE_REMOVED.id
    ? _c("RoleRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TAGS_ADDED.id
    ? _c("TagsAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TAGS_REMOVED.id
    ? _c("TagsRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WELCOME_MESSAGE_ADDED.id
    ? _c("WelcomeMessageAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WELCOME_MESSAGE_REMOVED.id
    ? _c("WelcomeMessageRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.BANNED_WORD_ADDED.id
    ? _c("BannedWordCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.BANNED_WORD_REMOVED.id
    ? _c("BannedWordRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_WORKFLOW_CREATED.id
    ? _c("TaskWorkflwCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.SETTINGS_UPDATED.id
    ? _c("SettingsUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.MAIL_ADDRESS_ADDED.id
    ? _c("MailAddressAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_ADDED_TO_DEPARTMENT.id
    ? _c("UserAddedToDepartment", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_REMOVED_FROM_DEPARTMENT.id
    ? _c("UserRemovedFromDepartment", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_DELETED.id
    ? _c("TaskDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHANNEL_VISIBILITY_CHANGED.id
    ? _c("ChannelVisibilityChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTENT_ADDED.id
    ? _c("ContentAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTENT_REMOVED.id
    ? _c("ContentRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CUSTOMER_GROUP_ADDED.id
    ? _c("CustomerGroupAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CUSTOMER_GROUP_REMOVED.id
    ? _c("CustomerGroupRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CUSTOMER_GROUP_UPDATED.id
    ? _c("CustomerGroupUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHAT_ASSIGNED_TO_USER.id
    ? _c("ChatAssigned", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHAT_FORWARDED_TO_USER.id
    ? _c("ChatForwarded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_JOINED_TO_CHAT.id
    ? _c("ChatJoined", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_LOGGED_IN.id
    ? _c("UserLoggedIn", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TICKET_ASSIGNED_TO_USER.id
    ? _c("TicketAssigned", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_CREATED.id
    ? _c("WhatsappBroadcastCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_COMPLETED.id
    ? _c("WhatsappBroadcastCompleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_CANCELED.id
    ? _c("WhatsappBroadcastCancelled", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_BROADCAST_FAILED.id
    ? _c("WhatsappBroadcastFailed", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_WORKFLOW_DELETED.id
    ? _c("TaskWorkflowDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.BILLING_ADDRESS_UPDATED.id
    ? _c("BillingAddressUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.INVOICE_CREATED.id
    ? _c("InvoiceCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.INVOICE_PAYMENT_RECEIVED.id
    ? _c("InvoicePaymentReceived", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.INVOICE_PAYMENT_FAILED.id
    ? _c("InvoicePaymentFailed", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.PAYMENT_METHOD_ADDED.id
    ? _c("PaymentMethodAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.INVOICE_REFUNDED.id
    ? _c("InvoiceRefunded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.LOGIN_FORM_ACTIVATED.id
    ? _c("LoginFormActivated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.LOGIN_FORM_DEACTIVATED.id
    ? _c("LoginFormDeactivated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.LOGIN_FORM_UPDATED.id
    ? _c("LoginFormUpdated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.USER_REMOVED.id
    ? _c("UserRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTACT_PROP_ADDED.id
    ? _c("ContactPropAdded", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CONTACT_PROP_REMOVED.id
    ? _c("ContactPropRemoved", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_CREATED.id
    ? _c("TaskCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_STAGE_CHANGED.id
    ? _c("TaskStageChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.TASK_ASSIGNED_TO_USER.id
    ? _c("TaskAssignedToUser", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.WHATSAPP_CREDIT_LOW.id
    ? _c("WhatsappCreditLow", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_CREATED.id
    ? _c("ChatbotCreated", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_CREDIT_LOW.id
    ? _c("ChatBotCreditLow", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_CREDIT_DONE.id
    ? _c("ChatBotCreditDone", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.SYSTEM_STATUS.id
    ? _c("SystemStatusChanged", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_DELETED.id
    ? _c("ChatbotDeleted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.CHATBOT_PUBLISHED.id
    ? _c("ChatbotPublished", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.PLAN_STARTED.id
    ? _c("PlanStarted", { attrs: { activity: _vm.activity } })
    : _vm.activity.type === _vm.ActivityTypes.PLAN_CANCELED.id
    ? _c("PlanCanceled", { attrs: { activity: _vm.activity } })
    : _c("div", [_vm._v("\n    " + _vm._s(_vm.activity.type) + "\n")])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }